import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {first} from 'rxjs/operators';
import {ProductService} from '../../services/product.service';

declare var swal: any;

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    products: any[];
    @ViewChild(DataTableDirective) private dtElement;

    constructor(
        private productService: ProductService
    ) {
    }

    ngOnInit() {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.productService.getDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.products = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'name'},
                {data: 'product_stock'},
                {data: 'category', name: 'category.name'},
                {data: 'status_nice', name: 'status'},
            ]
        };
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    delete(category: any): void {
        swal.fire({
            title: '¿Estás seguro que deseas eliminar este registro?',
            showCancelButton: true,
            confirmButtonText: 'Si, elimínalo!',
            showLoaderOnConfirm: true,
            preConfirm: (arg) => {
                return this.productService.delete(category.id)
                    .pipe(first())
                    .subscribe(response => {
                        swal.fire({
                            title: 'Elemento eliminado con éxito',
                            type: 'success'
                        });
                        this.reloadTable();
                    }, error => {
                        swal.fire({
                            title: error,
                            type: 'error'
                        });
                        return error;
                    });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
        });
    }

}
